import { inject, Service } from '@angular/core';
import { UserUnifiedService } from '@thiememeulenhoff/ng-api-gateway';
import { UserData } from '@thiememeulenhoff/types';
import { tap } from 'rxjs';
import { UserRecentStore } from '../user-recent/user-recent.store';
import { PreferenceStore } from '../preference/preference.store';
import { UserSettingStore } from '../user-setting';

@Service()
export class UserUnifiedFacade {
  readonly #userUnifiedService = inject(UserUnifiedService);

  readonly #preferenceStore = inject(PreferenceStore);

  readonly #userSettingStore = inject(UserSettingStore);

  readonly #userRecentStore = inject(UserRecentStore);

  initialize() {
    this.fetchUserData().subscribe();
  }

  fetchUserData() {
    return this.#userUnifiedService.fetchUserData().pipe(
      tap((userData: UserData) => {
        const preferences = userData.methodPreferences;
        this.#preferenceStore.setMethodPreferences(preferences);

        const settings = userData.userSettings;
        this.#userSettingStore.setUserSettings(settings);

        this.#userRecentStore.setRecents([
          ...(userData.recentMethods ?? []),
          ...(userData.recentArrangements ?? []),
          ...(userData.recentResources ?? []),
        ]);
      }),
    );
  }
}
